export const getUrlFriendlySlug = name => {
  if (!name) {
    return '';
  }

  return name
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

export const getHomeUrl = currentLocale => {
  if (!currentLocale) {
    return process.env.APP_URL;
  }

  const language = currentLocale.split(/[-_]/)[0];
  const baseUrl = process.env.APP_URL.replace(/\/$/, '');
  return language === 'en' ? baseUrl : `${baseUrl}/${language}`;
};
